<template>
  <collapse :collapse="['Products Accessed']" icon="keyboard_arrow_down" cardIcon="donut_small" color-collapse="info" :active="true">
    <template slot="md-collapse-pane-1">
      <PulseLoader :loading="!subscriptionsInfo" :class="{hide: subscriptionsInfo}"></PulseLoader>
      <div class="md-layout py-4" v-if="subscriptionsInfo">
        <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25 p-4">
          <chart-card
            header-animation="false"
            :chart-data="productsAccessed.data"
            :chart-options="productsAccessed.options"
            chart-type="Pie"
            header-icon
            chart-inside-content
            :chart-primary-number="`${subscriptionsInfo.products_accessed}`"
            chart-primary-color="#3b7ef1"
          >
            <template slot="footer">
              <div class="md-layout">
                <div class="md-layout-item md-size-100">
                  <h6 class="category text-center">
                    Products accessed
                  </h6>
                </div>
                <div class="md-layout-item text-center">
                  <h4><span style="color: #3b7ef1">{{
                      subscriptionsInfo.products_accessed
                    }}</span></h4>
                </div>
              </div>
            </template>
          </chart-card>
        </div>
        <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25 p-4">
          <chart-card
            header-animation="false"
            :chart-data="retailValue.data"
            :chart-options="retailValue.options"
            chart-type="Pie"
            header-icon
            chart-inside-content
            :chart-primary-number="`${subscriptionsInfo.retail_value}`"
            chart-primary-color="#00cdca"
          >
            <template slot="footer">
              <div class="md-layout">
                <div class="md-layout-item md-size-100">
                  <h6 class="category text-center">
                    Retail value
                  </h6>
                </div>
                <div class="md-layout-item text-center">
                  <h4><span style="color: #00cdca">{{
                      subscriptionsInfo.retail_value
                    }}</span></h4>
                </div>
              </div>
            </template>
          </chart-card>
        </div>
        <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25 p-4">
          <chart-card
            header-animation="false"
            :chart-data="daysLeft.data"
            :chart-options="daysLeft.options"
            chart-type="Pie"
            header-icon
            chart-inside-content
            :chart-primary-number="`${this.subscriptionsInfo.days_left}`"
            chart-primary-color="#f3a811"
          >
            <template slot="footer">
              <div class="md-layout">
                <div class="md-layout-item md-size-100">
                  <h6 class="category text-center">
                    Days left
                  </h6>
                </div>
                <div class="md-layout-item text-center">
                  <h4>
                    <span style="color: #f3a811">{{
                      this.subscriptionsInfo.days_left
                    }}</span>/{{ this.subscriptionsInfo.days_total }}123
                  </h4>
                </div>
              </div>
            </template>
          </chart-card>
        </div>
        <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25 p-4">
          <chart-card
            header-animation="false"
            :chart-data="teamMembers.data"
            :chart-options="teamMembers.options"
            chart-type="Pie"
            header-icon
            chart-inside-content
            :chart-primary-number="`${subscriptionsInfo.team_members}`"
            chart-primary-color="#85c976"
          >
            <template slot="footer">
              <div class="md-layout">
                <div class="md-layout-item md-size-100">
                  <h6 class="category text-center">
                    Team members
                  </h6>
                </div>
                <div class="md-layout-item text-center">
                  <h4><span style="color: #85c976">{{
                      subscriptionsInfo.team_members
                    }}</span></h4>
                </div>
              </div>
            </template>
          </chart-card>
        </div>
        <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 card-buttons">
            <md-button class="md-info md-round mt-4" :href="'/'" target="_blank">Upgrade Account <md-icon>admin_panel_settings</md-icon></md-button>
        </div>
      </div>
    </template>
  </collapse>
</template>
<script>
import { ChartCard, PulseLoader, Collapse } from '@/components';

export default {
  name: 'renew-upgrade-tab',
  props: {},
  components: {
    ChartCard,
    PulseLoader,
    Collapse
  },
  data() {
    return {};
  },
  methods: {},
  computed: {
    subscriptionsInfo() {
      return this.$store.getters.subscriptionsInfo;
    },
    productsAccessed() {
      return {
        data: {
          series: [
            {
              value: 100,
              className: 'secondary',
            },
          ],
        },
        options: {
          height: '230px',
          width: '230px',
          donut: true,
          donutWidth: 10,
          startAngle: 0,
          total: 100,
          showLabel: false,
        },
      };
    },
    retailValue() {
      return {
        data: {
          series: [{ value: 100, className: 'cyan' }],
        },
        options: {
          height: '230px',
          width: '230px',
          donut: true,
          donutWidth: 10,
          startAngle: 0,
          total: 100,
          showLabel: false,
        },
      };
    },
    daysLeft() {
      return {
        data: {
          series: [
            { value: this.subscriptionsInfo.days_left, className: 'gold' },
            {
              value:
                this.subscriptionsInfo.days_total -
                this.subscriptionsInfo.days_left,
              className: 'gold-light',
            },
          ],
        },
        options: {
          height: '230px',
          width: '230px',
          donut: true,
          donutWidth: 10,
          startAngle: 0,
          total: this.subscriptionsInfo.days_total,
          showLabel: false,
        },
      };
    },
    teamMembers() {
      return {
        data: {
          series: [{ value: 100, className: 'green' }],
        },
        options: {
          height: '230px',
          width: '230px',
          donut: true,
          donutWidth: 10,
          startAngle: 0,
          total: 100,
          showLabel: false,
        },
      };
    },
  },
};
</script>
<style></style>
